import { request } from "@/api/request";

/**
 * 图片上传 oss
 * @param params
 * @returns
 */
export const uploadAndGetOssFile = async (data) => {
  return request({
    name: 'robotChat.uploadAndGetOssFile',
    data,
  });
};

/**
 * 获取聊天记录
 * @param params
 * @returns
 */
export const getChatRecords = async (data) => {
  return request({
    name: 'robotChat.getHistory',
    data,
  });
};

/**
 * 获取聊天记录（第二版）
 * @param params
 * @returns
 */
export const getChatRecordsV2 = async (data) => {
  return request({
    name: 'robotChat.getHistoryV2',
    data,
  });
};

/**
 * 获取历史会话
 * @param params
 * @returns
 */
export const getChatSessionPaging = async (data) => {
  return request({
    name: 'robotChat.getChatSession',
    data,
  });
};

/**
 * 获取猜你想问
 * @param params
 * @returns
 */
export const getGuessYourQuestion = async (data) => {
  return request({
    name: 'robotChat.guessYourQuestion',
    data,
  });
};

/**
 * 获取一些菜单
 * @param params
 * @returns
 */

export const getChatMenu = async (data) => {
  return request({
    name: 'robotChat.getChatMenu',
    data,
  });
};

/**
 * 机器人-超链接跳转记录
 * @param params
 * @returns
 */

export const hyperlinkRecord = async (data) => {
  return request({
    name: 'apis.hyperlinkRecord',
    data,
  });
};

export const provinceAndCity = async (params: {
  parentId: string;
  size: number;
}) => {
  return request({
    // name: 'apis.provinceAndCity',
    url: 'https://wuyou-order-hq-test.sto.cn/esearch/provinceAndCity',
    params,
  });
};

/**
 * 获取联想列表
 * @param params
 * @returns
 */
export const getSearchList = async (data) => {
  return request({
    name: 'robotChat.getSearchList',
    data,
    loading: false,
  });
};

/**
 * 获取联想列表
 * @param params
 * @returns
 */
export const getSubscriptionList = async (data) => {
  return request({
    name: 'robotChat.getSubscriptionList',
    data,
    loading: false,
  });
};

/**
 * 用户订阅编辑
 * @param params
 * @returns
 */
export const editSubscription = async (data) => {
  return request({
    name: 'robotChat.editSubscription',
    data,
    loading: true,
  });
};

/**
 * 用户订阅删除
 * @param params
 * @returns
 */
export const deleteSubscription = async (id) => {
  return request({
    // name: 'robotChat.deleteSubscription',
    url: `/subscription/delete/${id}`,
    method: 'DELETE',
  });
};

/**
 * 用户订阅详情
 * @param params
 * @returns
 */
export const getSubscriptionDetail = async (id) => {
  return request({
    // name: 'robotChat.getSubscriptionDetail',
    url: `/subscription/detail/${id}`,
  });
};

/**
 * 用户订阅创建
 * @param params
 * @returns
 */
export const createSubscription = async (data) => {
  return request({
    name: 'robotChat.createSubscription',
    data,
    loading: true,
  });
};

/**
 * 订阅历史记录列表
 * @param params
 * @returns
 */
export const getSubscriptionRecordList = async (data) => {
  return request({
    name: 'robotChat.getSubscriptionRecordList',
    data,
    loading: false,
  });
};

/**
 * 更新会话内容
 * @param params
 * @returns
 */
export const updateContent = async (data) => {
  return request({
    name: 'robotChat.updateContent',
    data,
    loading: false,
  });
};

/**
 * 获取未读消息数
 * @param params
 * @returns
 */
export const getUnReadCount = async () => {
  return request({
    name: 'robotChat.unReadCount',
    loading: false,
  });
};

/**
 * 订阅状态开关
 * @param params
 * @returns
 */
export const switchStatus = async (data) => {
  return request({
    name: 'robotChat.switchStatus',
    loading: true,
    data,
  });
};

/**
 * AI悬浮机器人-推荐消息播报
 * @param params
 * @returns
 */
export const recommendPolling = async (data) => {
  return request({
    name: 'robotChat.recommendPolling',
    data,
    loading: false,
  });
};


/**
 * AI悬浮机器人-推荐消息播报
 * @param params
 * @returns
 */
export const pollingParams = async () => {
  return request({
    name: 'robotChat.pollingParams',
    loading: false,
  });
};